<mat-card class="mouter">
    <div class="headcontent">
        <div class="pophead">
            <h3>Add User</h3>
            <mat-icon (click)="close()" class="close">close</mat-icon>
        </div>
    </div>
    <div class="dialog_content">
        <form [formGroup]="userDetailform" class="fix-mat-form-field">

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="legacy" fxFlex>
                    <mat-label>First Name</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input matInput placeholder="First Name" formControlName="firstname"
                        (keypress)="allowAlphabetOnly($event)" #firstname>
                    <mat-error>
                        {{ titleAlert }}
                    </mat-error>
                </mat-form-field>
            </div>
            <!-- (keyup)="checkregex()" -->
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="legacy" fxFlex>
                    <mat-label>Last Name</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input matInput placeholder="Last Name" formControlName="lastname"
                        (keypress)="allowAlphabetOnly($event)">
                    <mat-error>
                        {{ titleAlert }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="legacy" fxFlex>
                    <mat-label>Email</mat-label>
                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                    <input matInput placeholder="Email" formControlName="email" (blur)="checkInUseEmail()"
                        autocomplete="false">
                    <mat-error>
                        {{ getErrorEmail() }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="choose" appearance="legacy" fxFlex>
                    <mat-label>Enter your password</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" formControlName="password"
                        placeholder="Enter your password" autocomplete="off">
                    <mat-icon class="eye" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-hint class="errorpass">Choose a password of at least eight characters with one uppercase
                        letter, one lowercase letter, one special character and one number
                    </mat-hint>
                    <mat-error class="errorpass">
                        {{ getErrorPassword() }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="legacy" fxFlex>
                    <mat-label>Confirm your password</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" placeholder="Confirm your password"
                        formControlName="confirmPassword" (keyup)="matchPassword()" autocomplete="off">
                    <span matSuffix class="eye" (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </span>
                    <mat-error>
                        Password does not match
                    </mat-error>
                </mat-form-field>
            </div>



            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="example-full-width">
                    <mat-label>Telephone</mat-label>
                    <span matPrefix>+1 &nbsp;</span>
                    <input matInput placeholder="Telephone" formControlName="phoneNumber" mask="(000) 000-0000">
                    <mat-error>{{getPhoneErrorMessage()}}</mat-error>
                    <mat-icon matSuffix>local_phone</mat-icon>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-list-item role="listitem" class="fullw">
                    <mat-form-field appearance="legacy" fxFlex class="rolesDropdown ">
                        <mat-select placeholder="Roles" name="role" formControlName="selectedroles" multiple>
                            <mat-option *ngFor="let role of roles" [value]="role.roleID">
                                {{role.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-list-item>
            </div>

            <div appearance="legacy" fxFlex>
                <mat-checkbox formControlName="isActive" color="primary" [(ngModel)]="isActiveChecked">Active
                </mat-checkbox>
            </div>
        </form>

    </div>



    <div class="actionBtn">
        <button mat-flat-button class="cancel" (click)="close()">Cancel</button>
        <button mat-flat-button class="calltoaction" type="submit" [disabled]="!userDetailform.valid"
            (click)="save(userDetailform.value)" color="primary">Create</button>
    </div>
</mat-card>